<template>
  <div class="saving">
    <h5>
      <b>Savings </b>
      <span> (Accessible on the </span>
      <img src="@/assets/img/opay-logo.png" />
      <span> App)</span>
    </h5>
    <div class="cont">
      <div class="left">
        <div class="prev" @click="prev">
          <img src="@/assets/img/prev.png" alt="" />
        </div>
        <el-carousel
          ref="carousel"
          arrow="never"
          height="100%"
          class="my-swiper"
          trigger="click"
          indicator-position="none"
          @change="handleCurrentChange"
        >
          <el-carousel-item name="0" class="swiper-slide">
            <img src="@/assets/img/owealth.png" alt="" />
          </el-carousel-item>
          <el-carousel-item name="1" class="swiper-slide">
            <img src="@/assets/img/fixed.png" alt="" />
          </el-carousel-item>
          <el-carousel-item name="2" class="swiper-slide">
            <img src="@/assets/img/targets.png" alt="" />
          </el-carousel-item>
          <el-carousel-item name="3" class="swiper-slide">
            <img src="@/assets/img/safebox.png" alt="" />
          </el-carousel-item>
          <el-carousel-item name="4" class="swiper-slide">
            <img src="@/assets/img/spend.png" alt="" />
          </el-carousel-item>
        </el-carousel>
        <div class="next" @click="next">
          <img src="@/assets/img/next.png" alt="" />
        </div>
      </div>
      <div class="right">
        <ul class="list">
          <li
            v-for="(item, ind) in list"
            :key="ind"
            @click="onClick(ind)"
            :class="{ active: ind === activeInd }"
          >
            <span class="list-itm-title">{{ item.title }}</span>
            <span v-html="item.html"></span>
          </li>
        </ul>
        <p class="tips">
          OPay MFB savings products can be accessed on the
          <img src="@/assets/img/opay-logo.png" alt="" />
          mobile app
        </p>
        <img
          class="google_play app-store"
          src="@/assets/img/app-store.png"
          alt=""
          @click="toIos"
        />
        <img
          class="google_play"
          src="@/assets/img/google_play.png"
          alt=""
          @click="toGp"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeInd: 0,
      swiper: null,
      list: [
        {
          title: "OWealth",
          html: "Use as Balance with Monthly Interest",
        },
        {
          title: "Fixed",
          html: "Gain large returns",
        },
        {
          title: "Targets",
          html: "Save with discipline towards a specific goal",
        },
        {
          title: "SafeBox",
          html: "Save daily, weekly, or monthly",
        },
        {
          title: "Spend & Save",
          html: "Save as you spend",
        },
      ],
    };
  },
  methods: {
    onClick(ind) {
      this.activeInd = ind;
      this.$refs.carousel.setActiveItem(ind);
    },
    prev() {
      this.$refs.carousel.prev();
      this.activeInd = this.activeInd - 1;
      if (this.activeInd < 0) {
        this.activeInd = 2;
      }
    },
    next() {
      this.$refs.carousel.next();
      this.activeInd = this.activeInd + 1;
      if (this.activeInd === 3) {
        this.activeInd = 0;
      }
    },
    handleCurrentChange(ind) {
      this.activeInd = ind;
    },
    toIos() {
      window.location.href =
        "https://apps.apple.com/cn/app/opay-we-are-beyond-banking/id1463776084";
    },
    toGp() {
      window.location.href =
        "https://play.google.com/store/apps/details?id=team.opay.pay&hl=en&gl=NG";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/public.scss";

.saving {
  width: 100%;
  background-image: url("~@/assets/img/saving-bg.png");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 80px 120px 0;
  h5 {
    vertical-align: middle;
    font-family: "Poppins";
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    text-align: center;
    b {
      color: #210f60;
      font-family: "Poppins";
      font-size: 40px;
      font-style: normal;
      font-weight: 600;
    }
    img {
      width: 70px;
      vertical-align: middle;
    }
  }
}
.cont {
  @include flex-base;
  margin-top: 56px;
}
.left {
  flex: 1;
  overflow: hidden;
  @include flex-center;
  .prev,
  .next {
    img {
      width: 46px;
      height: 46px;
    }
  }
}
.right {
  width: 630px;
  padding-bottom: 38px;
  .list {
    li {
      height: 48px;
      margin-bottom: 56px;
      cursor: pointer;
      span {
        display: block;
        color: rgba(0, 0, 0, 0.85);
        font-size: 24px;
        font-family: "Poppins";
        margin-left: 24px;
        vertical-align: middle;
      }
      .list-itm-title {
        font-size: 32px;
        font-weight: 500;
        font-family: "Poppins";
      }
      &.active {
        span {
          color: #744ce9;
        }
      }
    }
  }
  .tips {
    font-size: 14px;
    margin-bottom: 34px;
    padding-left: 24px;
    img {
      width: 60px;
      margin: 0 3px;
      vertical-align: middle;
    }
  }
  .google_play {
    width: 270px;
    height: 80px;
    cursor: pointer;
    margin-left: 24px;
    margin-bottom: 40px;
  }
  .app-store {
    margin-right: 19px;
  }
}

.my-swiper {
  width: 406px;
  height: 745px;
  position: relative;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  margin: 0 20px;
  .swiper-slide {
    width: 100%;
    height: 100%;
    overflow: hidden;
    text-align: center;
    transform: translate3d(0, 0, 0);
    img {
      width: 406px;
      height: 745px;
    }
  }
}
</style>
